"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const protobuf_1 = require("../generated/protobuf");
exports.TopicMessage = {
    [protobuf_1.TOPIC.RECORD]: protobuf_1.RecordMessage,
    [protobuf_1.TOPIC.CLUSTER]: protobuf_1.ClusterMessage,
    [protobuf_1.TOPIC.CONNECTION]: protobuf_1.ConnectionMessage,
    [protobuf_1.TOPIC.AUTH]: protobuf_1.AuthMessage,
    [protobuf_1.TOPIC.EVENT]: protobuf_1.EventMessage,
    [protobuf_1.TOPIC.LOCK]: protobuf_1.LockMessage,
    [protobuf_1.TOPIC.MONITORING]: protobuf_1.MonitoringMessage,
    [protobuf_1.TOPIC.PARSER]: protobuf_1.ParserMessage,
    [protobuf_1.TOPIC.PRESENCE]: protobuf_1.PresenceMessage,
    [protobuf_1.TOPIC.RPC]: protobuf_1.RpcMessage
};
//# sourceMappingURL=protobuf-map.js.map